module.exports = __webpack_public_path__ + "img/logo-light-text.0980e73c.png";